import React from 'react';
import { FormattedMessage } from 'react-intl';
import logoPngBlack from 'assets/images/logo_paynow_black.svg';
import {
  NotificationContainer,
  NotificationText,
  NotificationTextBold,
  LoaderContainer,
  LineTop,
  LineBottom,
} from './RedirectNotification.styles';

function RedirectNotification({ type }: { type: string }) {
  return (
    <NotificationContainer className="redirect-screen-notification-container">
      <LineTop />
      <img className="logo" alt="logo" src={logoPngBlack} />
      {/* outer middle and inner div for page centering */}
      <div className="outer">
        <div className="middle">
          <div className="inner">
            <LoaderContainer />
            <NotificationTextBold>
              <FormattedMessage id={`notification.${type}.message1`} />
            </NotificationTextBold>
            <NotificationText>
              <FormattedMessage id={`notification.${type}.message2`} />
            </NotificationText>
          </div>
        </div>
      </div>
      <LineBottom />
    </NotificationContainer>
  );
}

export default RedirectNotification;
